import { render } from "./NotfoundPage.vue?vue&type=template&id=1c1635ba&scoped=true"
import script from "./NotfoundPage.vue?vue&type=script&lang=js"
export * from "./NotfoundPage.vue?vue&type=script&lang=js"

import "./NotfoundPage.vue?vue&type=style&index=0&id=1c1635ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1635ba"]])

export default __exports__